module.exports = __webpack_public_path__ + "img/dry_martini.d0d37498.jpg";